import React, { useEffect, useMemo, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";



import {
  Box,
  Typography,
  Link,
  Chip,
  Checkbox,
  Pagination,
  Tooltip,
} from "@mui/material";
import EditIcon from "../../../src/assests/images/edit-2.svg";
import DeleteIcon from "../../../src/assests/images/trash.svg";
import FilterTags from "./FilterTags";
import PaginationComponent from "./Pagination";
import ScheduledAssign from "./ScheduledAssign";
import RenderSelectedFilters from "./RenderSelectedFiltersProps";
import { useLocation } from "react-router-dom";
import Sorting from "../../assests/images/Sorting.svg";

import { getcohort } from "../../pages/assign-task/api";


interface RowData {
  id: number;
  pmpmiEntityCodei: string;
  retailerName: string;
  outletName: string;
  outletType: string;
  location: string;
  asm: string;
  distribution: string;
  salesVolume: string;
  user_ids: string
}
interface CohortUserTableProps {
  data: RowData[];
  checkbaledata: any[];
  missingidss: any
  maintasknamess:any
  cohortname: string;
  totalPages: string;
  combineddata: string;
  cohorttaskid: string
  selectedDate1: Date | null;
  setSelectedDate1: React.Dispatch<React.SetStateAction<Date | null>>;
  selectedTime: string | null;
  setSelectedTime: React.Dispatch<React.SetStateAction<string | null>>;
  page: number; setPage: React.Dispatch<React.SetStateAction<number>>
  searchlegth: number
}
interface TaskData { task_name: string; credit_points: string; durations: string; }
const CohortUserTable: React.FC<CohortUserTableProps> = ({ maintasknamess,missingidss, combineddata, data, searchlegth, cohortname, totalPages, cohorttaskid, selectedDate1, setSelectedDate1, selectedTime, setSelectedTime, page, setPage, checkbaledata }) => {

  console.log(data, "datadatadata")
 const [userdatadata, setuserdatadata] = useState("");

const [gettaskdata, setGetTaskData] = useState<TaskData | null>(null);
const [selectedTaskIds, setSelectedTaskIds] = useState<string[]>([]);
  const [cohortSchedules, setCohortSchedules] = useState<{ [key: string]: string }>({});
  const [totalCreditPoints, setTotalCreditPoints] = useState(0);
  const [totalRetailers, setTotalRetailers] = useState(0);
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof RowData | "">("");
const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [unselected, setUnselected] = useState([]);
  const [missingidssssss, setMissingidssssss] = useState<number[]>([]);
const [assignedCount, setassignesCount] = useState(0);
  const [selected, setSelected] = useState<number[]>([]);
  const [selected22, setSelected22] = useState<number[]>([]);
  const [unselectedIds, setUnselectedIds] = useState<number[]>([]);
  const [selected11, setSelected11] = useState<number[]>([]);
const [selectedCohortStatuses, setSelectedCohortStatuses] = useState<Record<string, string>>({});
  const location = useLocation();
  useEffect(() => {
    if (location.state?.idifisdi || location.state?.idifisdi) {
      console.log(location.state?.idifisdi, "location.state?.idifisdi")


      // settotalcountoultes(location.state.valuetabsdatapagelengthselectedRows);
    }
  }, [location.state]);
  // const rows: RowData[] = [
  //   {
  //     id: 1,
  //     pmpmiEntityCodei: "12345id",
  //     retailerName: "Aman",
  //     outletName: "Aman Pan Shop",
  //     outletType: "Paid",
  //     location: "Delhi",
  //     asm: "Aman Pan Shop",
  //     distribution: "XYZ",
  //     salesVolume: "Approved",
  //   },
  //   {
  //     id: 2,
  //     pmpmiEntityCodei: "12346id",
  //     retailerName: "Aman PMI",
  //     outletName: "Aman Pan Shop",
  //     outletType: "Paid",
  //     location: "Delhi",
  //     asm: "Aman Pan Shop",
  //     distribution: "XYZ",
  //     salesVolume: "Approved",
  //   },
  // ];

  const handleSort = (property: keyof RowData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      console.log(event.target.checked, "cccccccccccccccccc")
      setSelected(sortedRows.map((row) => row.id));
    } else {
      setSelected([]);
    }
  };
  console.log(checkbaledata, "checkbaledata")
  const handleSelectRow = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    const isInCheckbaledata = checkbaledata.includes(id);

    if (event.target.checked) {
      console.log(id, "Checked");

      setSelected((prevSelected) => [...prevSelected, id]);

      // Remove from unselectedIds ONLY if id is in checkbaledata
      if (isInCheckbaledata) {
        setUnselectedIds((prev) => prev.filter((deselectedId) => deselectedId !== id));
      }
    } else {
      // Prevent unchecking if the id is in selected22
      if (selected22.includes(id)) {
        console.log(`ID ${id} is protected and cannot be unchecked.`);
        return;
      }

      setSelected((prevSelected) =>
        prevSelected.filter((selectedId) => selectedId !== id)
      );

      // Add to unselectedIds ONLY if id is in checkbaledata
      if (isInCheckbaledata) {
        setUnselectedIds((prev) => [...prev, id]);
      }
    }
  };


  console.log(selected, "selectedselected222222ssss")
  console.log(selected11, "selected11selected11selected11")

  const sortedRows = useMemo(() => {
    return [...data].sort((a, b) => {
      if (!orderBy) return 0;
      const aVal = a[orderBy];
      const bVal = b[orderBy];
      if (aVal < bVal) return order === "asc" ? -1 : 1;
      if (aVal > bVal) return order === "asc" ? 1 : -1;
      return 0;
    });
  }, [data, orderBy, order]);

  console.log(sortedRows, "sortedRowssortedRows")

const rentalPattern = /^\d+-\d+$/;        // e.g. "2000-4000"
const contractPattern = /^Last\d+Year$/i; // e.g. "Last6Year"

const formatLabel = (value: string) => {
  if (rentalPattern.test(value)) {
    const [min, max] = value.split("-");
    return `₹${min}-₹${max}`;
  }
  if (contractPattern.test(value)) {
    return value
      .replace(/([A-Za-z]+)(\d+)/, "$1 $2")   // Last6Year → Last 6Year
      .replace(/(\d+)([A-Za-z]+)/, "$1 $2"); // Last 6Year → Last 6 Year
  }
  return value; // default (e.g. "Paid")
};

// const formattedFilters = (
//   typeof combineddata === "string"
//     ? combineddata
//         .split(",")
//         .map((item) => item.trim())
//         .filter((item) => item !== "")
//     : Object.entries(combineddata)
//         .filter(([_, value]) => Boolean(value))
//         .map(([key]) => key)
//         .filter((item) => item !== "")
// ).map(formatLabel);

const formattedFilters = (
  typeof combineddata === "string"
    ? combineddata
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "")
    : Object.entries(combineddata)
        .filter(([_, value]) => Boolean(value))
        .map(([key]) => key)
        .filter((item) => item !== "")
).map((item) => {
  // List of items that should be ALL CAPS
  const toCapitalize = ["delhi ncr", "mumbai"];

  if (toCapitalize.includes(item.toLowerCase())) {
    return item.toUpperCase();
  }
  return formatLabel(item);
});

console.log(formattedFilters);
// Example: ["DELHI NCR", "MUMBAI", "Paid"]


  // const formattedFilters = typeof combineddata === "string"
  //   ? combineddata.split(',').map(item => item.trim()).filter(item => item !== "")
  //   : Object.entries(combineddata)
  //     .filter(([_, value]) => Boolean(value))
  //     .map(([key]) => key)
  //     .filter(item => item !== "");
console.log(formattedFilters, "formattedFiltersformattedFilters")
  useEffect(() => {
    if (sortedRows.length > 0) {
      const allIds = sortedRows
        .filter(row => row.user_ids === "exist")
        .map(row => row.id);

      console.log(allIds, "Filtered selected IDs");
      setSelected(allIds);
      setSelected22(allIds)

    }
  }, [sortedRows, page]);
  console.log(selected22, "selected22999995511222333333")
  console.log(sortedRows, "formattedFiltersformattedFilters")
  console.log(combineddata, "combineddatasssssssss")
  console.log(totalPages, "totalPagessssssss")
  console.log(selected, "selectedselectedselected")
  console.log(data, "datasssssssssssss")

  console.log(unselectedIds, "unselectedIdswwwwwwww")




  useEffect(() => {
    const currentFiltered = selected.filter(id => missingidss.includes(id));

    setMissingidssssss(prev => {
      const updated = [...prev];
      currentFiltered.forEach(id => {
        if (!updated.includes(id)) {
          updated.push(id);
        }
      });
      return updated;
    });
  }, [selected, missingidss]);

  console.log(missingidssssss, "missingidsssssssssssseeeeeeeeeeee",maintasknamess)
  console.log(formattedFilters, "formattedFiltersformattedFilters", combineddata, "combineddatacombineddata")
  return (
    <>
      <Box sx={{ paddingTop: "30px", background: "#F9FBFC", borderTop: "1px solid #c1c4c6", marginBottom: "100px" }}>
        <Box sx={{ padding: "0 32px", }}>
          <Box
            sx={{
              display: "flex",
              background: "#fff",
              border: "2px solid #F1F2F3",
              alignItems: "center",
              justifyContent: "space-between",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
              boxShadow: "-1px 1px 1px #e7e8e9"
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: "16px",
                color: "#282829",
                fontWeight: "600",
                padding: "20px",
                background: "#fff",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            >
              {`${cohortname} (${searchlegth} Users)`}


            </Typography>

{maintasknamess.length > 0 && (

<Typography
              variant="h3"
              sx={{
                fontSize: "16px",
                color: "#282829",
                fontWeight: "600",
                padding: "20px",
                background: "#fff",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            >
           Task names: {maintasknamess.join(", ")}


            </Typography>
)}
            {/* <Typography sx={{ marginTop: "20px" }}>
              <Tooltip title="Delete">
                <Link
                  href="#"
                  sx={{
                    textDecoration: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "rgba(105, 106, 107, 1)",
                    marginRight: "20px",
                  }}
                >
                  <img src={DeleteIcon} alt="Edit Icon" width="20px" />
                </Link>
              </Tooltip>
              <Tooltip title="Edit">
                <Link
                  href="assign-task-cohort"
                  sx={{
                    textDecoration: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "rgba(105, 106, 107, 1)",
                    marginRight: "20px",
                  }}
                >
                  <img src={EditIcon} alt="Edit Icon" />
                </Link>
              </Tooltip>
            </Typography> */}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              padding: "10px 20px",
              background: "#fff",
              border: "1px solid #d7d3d3",
              borderTop: "none",

            }}
          >

            {/* <FilterTags
              title="Applied Filters :"
              maxVisible={8}
              showAllInitially={true}
              showCloseBtn={false}
            /> */}

            {combineddata && (
              <FilterTags
                title="Applied Filters:"

                combainesalldata={formattedFilters}
                // maxVisible={8}
                showAllInitially={false}
                showCloseBtn={false} appliedFilters={""} />
            )}

            <RenderSelectedFilters
              maxVisible={3}
              showAllInitially={false}
              showTitle={true}
              title=""
              // title="Applied Filters"
              showCloseBtn={false} // Toggle this to hide/show delete button
              filters={{}} tasks={[]}

            />
          </Box>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="sortable table">
              <TableHead sx={{ background: "#EEF4FF" }}>
                <TableRow>
                  {/* <TableCell padding="checkbox">
                    <Checkbox
                      checked={selected.length === data.length}
                      onChange={handleSelectAll}
                      inputProps={{ "aria-label": "select all" }}
                      sx={{
                        color: "#E7E8E9",
                        "&.Mui-checked": {
                          color: "#0073e6",
                        },
                      }}
                    />
                  </TableCell> */}
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "pmpmiEntityCodei"}
                      direction={orderBy === "pmpmiEntityCodei" ? order : "asc"}
                      onClick={() => handleSort("pmpmiEntityCodei")}
                      IconComponent={() => (
                        <img
                          src={Sorting}
                          alt="sort"
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "6px",
                            opacity: orderBy === "pmpmiEntityCodei" ? 1 : 1, // 1 when active, faded otherwise
                            transition: "opacity 0.2s ease-in-out",
                          }}
                        />
                      )}
                    >
                      PMI Entity Code
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "retailerName"}
                      direction={orderBy === "retailerName" ? order : "asc"}
                      onClick={() => handleSort("retailerName")}
                      IconComponent={() => (
                        <img
                          src={Sorting}
                          alt="sort"
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "6px",
                            opacity: orderBy === "pmpmiEntityCodei" ? 1 : 1, // 1 when active, faded otherwise
                            transition: "opacity 0.2s ease-in-out",
                          }}
                        />
                      )}
                    >
                      Retailer Name
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "outletName"}
                      direction={orderBy === "outletName" ? order : "asc"}
                      onClick={() => handleSort("outletName")}
                      IconComponent={() => (
                        <img
                          src={Sorting}
                          alt="sort"
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "6px",
                            opacity: orderBy === "pmpmiEntityCodei" ? 1 : 1, // 1 when active, faded otherwise
                            transition: "opacity 0.2s ease-in-out",
                          }}
                        />
                      )}
                    >
                      Outlet Name
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "outletType"}
                      direction={orderBy === "outletType" ? order : "asc"}
                      onClick={() => handleSort("outletType")}
                      IconComponent={() => (
                        <img
                          src={Sorting}
                          alt="sort"
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "6px",
                            opacity: orderBy === "pmpmiEntityCodei" ? 1 : 1, // 1 when active, faded otherwise
                            transition: "opacity 0.2s ease-in-out",
                          }}
                        />
                      )}
                    >
                      Outlet Type
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "location"}
                      direction={orderBy === "location" ? order : "asc"}
                      onClick={() => handleSort("location")}
                      IconComponent={() => (
                        <img
                          src={Sorting}
                          alt="sort"
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "6px",
                            opacity: orderBy === "pmpmiEntityCodei" ? 1 : 1, // 1 when active, faded otherwise
                            transition: "opacity 0.2s ease-in-out",
                          }}
                        />
                      )}
                    >
                      Location
                    </TableSortLabel>
                  </TableCell>
                  {/* <TableCell>
                    <TableSortLabel
                      active={orderBy === "asm"}
                      direction={orderBy === "asm" ? order : "asc"}
                      onClick={() => handleSort("asm")}
                    >
                      ASM
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "distribution"}
                      direction={orderBy === "distribution" ? order : "asc"}
                      onClick={() => handleSort("distribution")}
                    >
                      Distribution
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={orderBy === "salesVolume"}
                      direction={orderBy === "salesVolume" ? order : "asc"}
                      onClick={() => handleSort("salesVolume")}
                    >
                      Sales Volume
                    </TableSortLabel>
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedRows.map((row, index) => (
                  <TableRow key={row.id} sx={{ backgroundColor: index % 2 !== 0 ? "#F9FBFC" : "transparent", }}>
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        checked={selected.includes(row.id)}

                        onChange={(event) => handleSelectRow(event, row.id)}
                        inputProps={{ "aria-label": `select row ${row.id}` }}
                        sx={{
                          color: "#E7E8E9",
                          "&.Mui-checked": {
                            color: "#0073e6",
                          },
                        }}
                      />
                    </TableCell> */}
                    <TableCell>{row.pmpmiEntityCodei}</TableCell>
                    <TableCell>{row.retailerName}</TableCell>
                    <TableCell>{row.outletName}</TableCell>
                    <TableCell>{row.outletType}</TableCell>
                    <TableCell>{row.location}</TableCell>
                    {/* <TableCell>{row.asm}</TableCell>
                    <TableCell>{row.distribution}</TableCell>
                    <TableCell>{row.salesVolume}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          sx={{
            background: "#fff",
            border: "1px solid rgba(224, 224, 224, 1)",
            borderTop: "none",
            margin: "0 32px 50px",
            boxShadow: "-1px 1px 1px #e7e8e9",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            padding: "10px 0"
          }}
        >
          <PaginationComponent
            page={page}
            limit={10}
            totalPages={Number(totalPages)} // Ensure it's a number
            setPage={setPage}
          />




        </Box>
      </Box>
      <Box>
        <ScheduledAssign   totalCreditPoints={totalCreditPoints}
        setTotalCreditPoints={setTotalCreditPoints}
        totalRetailers={totalRetailers}
        setTotalRetailers={setTotalRetailers}    cohortSchedules={cohortSchedules}
        setCohortSchedules={setCohortSchedules} userdatadata={userdatadata} selectedTaskIds={selectedTaskIds}            // ✅ pass it here
  setSelectedTaskIds={setSelectedTaskIds} selectedCohortStatuses={selectedCohortStatuses}
      setSelectedCohortStatuses={setSelectedCohortStatuses}  assignedCount={assignedCount}  gettaskdata={gettaskdata}
    setGetTaskData={setGetTaskData}  selectedRows={selectedRows}
    setSelectedRows={setSelectedRows}  missingidssssss={missingidssssss} checkbaledata={checkbaledata} cohorttaskid={cohorttaskid} value={""} cohortIds={[]} selectedDate1={selectedDate1} setSelectedDate1={setSelectedDate1} selectedTime={selectedTime} setSelectedTime={setSelectedTime} selected={selected} unselectedIds={unselectedIds} />
      </Box>
    </>
  );
};

export default CohortUserTable;
